<template>
  <div class="coop-p-survey">
    <nav class="coop-c-skip-nav">
      <ul class="coop-c-skip-nav__list">
        <li>
          <a
            class="coop-c-skip-nav__link"
            href="#main"
            title="Skip to content"
          >Skip to content</a>
        </li>
        <li>
          <a
            class="coop-c-skip-nav__link"
            href="#navigation"
            title="Skip to navigation"
          >Skip to navigation</a>
        </li>
      </ul>
    </nav>

    <header class="ssn-header ssn">
      <nav aria-label="primary">
        <div class="ssn-header-inner ssn-wrap">
          <div class="ssn-logo">
            <svg
              width="38"
              height="40"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Co-op</title>
              <path
                fill="#00B1E7"
                d="M37.8 8.8c0-1.4-.2-2.8-.6-4.2-.5-1.7-1.8-3-3.4-3.7a14.9 14.9 0 0 0-10.2 0c-1.7.6-2.9 2-3.4 3.7-.8 2.8-.8 5.7 0 8.5.5 1.7 1.8 3 3.4 3.7 1.6.6 3.4.9 5.1.8 1.7 0 3.5-.3 5.1-.8 1.7-.6 2.9-2 3.4-3.7.4-1.5.6-2.9.6-4.3zm-5.5 0c0 .7-.1 1.4-.3 2-.3.9-1 1.6-2 1.8-.9.2-1.8.2-2.6 0-.9-.2-1.7-.8-2-1.8-.4-1.3-.4-2.8 0-4.1.3-.9 1-1.6 2-1.8.9-.2 1.8-.2 2.6 0 .9.2 1.7.8 2 1.8.2.7.3 1.4.3 2.1m-14.6 23c.8-2.8.8-5.7 0-8.5-.5-1.7-1.8-3-3.4-3.7a14.9 14.9 0 0 0-10.2 0c-1.7.6-2.9 2-3.4 3.7-.8 2.8-.8 5.7 0 8.5.5 1.7 1.8 3 3.4 3.7 3.3 1.2 6.9 1.2 10.2 0 1.6-.6 2.9-2 3.4-3.7m-4.9-4.2c0 .7-.1 1.4-.3 2-.3.9-1 1.6-2 1.8-.9.2-1.8.2-2.6 0-.9-.2-1.7-.8-2-1.8-.4-1.4-.4-2.8 0-4.1.3-.9 1-1.6 2-1.8.9-.2 1.8-.2 2.6 0 .9.2 1.7.8 2 1.8.2.7.3 1.4.3 2.1m0-18.9h5.5c0-1.4-.2-2.8-.6-4.2-.5-1.7-1.8-3-3.4-3.7C11-.3 7.4-.3 4.1.9c-1.7.6-2.9 2-3.4 3.7-.8 2.8-.8 5.7 0 8.5.5 1.7 1.8 3 3.4 3.7 1.6.6 3.4.8 5.1.8s3.5-.3 5.1-.8c1.7-.6 2.9-2 3.4-3.7.1-.2.1-.5.2-.7L12.7 10c-.1.3-.1.6-.2.9-.3.9-1 1.6-2 1.8-.9.2-1.8.2-2.6 0-.9-.2-1.7-.8-2-1.8-.4-1.4-.4-2.9 0-4.2.3-.9 1-1.6 2-1.8.9-.2 1.8-.2 2.6 0 .9.2 1.7.8 2 1.8.2.7.3 1.3.3 2m7.4 14.6c-.4 1.4-.6 2.8-.6 4.2V40h5.5V27.6c0-.7.1-1.4.3-2 .3-.9 1-1.6 2-1.8.9-.2 1.8-.2 2.6 0 .9.2 1.7.8 2 1.8.4 1.4.4 2.8 0 4.1-.3.9-1 1.6-1.9 1.8-.9.2-1.8.2-2.6 0-.2-.1-.4-.1-.5-.2l1.9 5.1c1.7 0 3.5-.3 5.1-.8 1.7-.6 2.9-2 3.4-3.7.8-2.8.8-5.7 0-8.5-.5-1.7-1.8-3-3.4-3.7a14.9 14.9 0 0 0-10.2 0c-1.9.6-3.1 2-3.6 3.6"
              />
            </svg>
          </div>
        </div>
        <div
          id="navigation"
          class="ssn-mainnav"
          data-action="ssn-overlay-toggle"
        >
          <div class="ssn-mainnav-inner" />
        </div>
      </nav>
    </header>

    <main
      id="main"
      class="coop-p-retirement-survey"
    >
      <TransitionGroup name="coop-t-fade">
        <SurveyIntro
          v-if="surveyStore.step === 0"
        />
        <template v-else-if="surveyStore.step <= surveyStore.totalSteps">
          <div class="coop-l-container coop-u-padding-b-64 coop-u-padding-resp-t-32-24">
            <SurveySteps />
          </div>
        </template>
        <SurveyClose v-else />
      </TransitionGroup>
    </main>
  </div>
</template>

<script setup>
// eslint-disable-next-line import/no-unresolved
import { useSurveyStore } from '@/stores/survey.js';
import SurveyIntro from '../Survey/SurveyIntro.vue';
import SurveySteps from '../Survey/SurveySteps.vue';
import SurveyClose from '../Survey/SurveyClose.vue';

const surveyStore = useSurveyStore();
</script>
